<app-option-button-group
	[isColorVariant]="isColorVariant"
	[label]="label"
	[labelKey]="label ? undefined : resolvedLabelKey"
	[options]="options"
	[ngModel]="value"
	[disabled]="disabled"
	(ngModelChange)="onSelect($event)"
></app-option-button-group>
